
import { Badge } from "@/components/ui/badge";
import { Category } from "./types";

interface CategoryKeywordsProps {
  categories: Category[];
  isLoading: boolean;
}

const CategoryKeywords = ({ categories, isLoading }: CategoryKeywordsProps) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  const categoriesWithKeywords = categories.filter(cat => cat.keywords && cat.keywords.length > 0);

  return (
    <div className="bg-background rounded-lg border p-6">
      <h3 className="text-lg font-medium mb-4">Category Keywords</h3>
      {categoriesWithKeywords.length > 0 ? (
        <div className="space-y-4">
          {categoriesWithKeywords.map((category) => (
            <div key={category.id} className="border-b pb-4">
              <h4 className="font-medium mb-2">{category.name}</h4>
              <div className="flex flex-wrap gap-2">
                {category.keywords?.map((keyword, index) => (
                  <Badge key={index} variant="secondary">
                    {keyword}
                  </Badge>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-4 text-muted-foreground">
          No categories with keywords found.
        </div>
      )}
    </div>
  );
};

export default CategoryKeywords;
